import {
    AfterViewChecked,
    Component, Input,
    OnDestroy,
    OnInit,
    QueryList,
    ViewChildren
} from '@angular/core';
import {ControlContainer, NgForm, NgModel} from '@angular/forms';

import {AddSupplyCategorisedModalComponent} from '../../add-supply-categorised-modal/add-supply-categorised-modal.component';
import {EditModalSectionBaseComponent} from '../edit-modal-section-base.component';
import {EditModalService} from '../../../services/edit-modal.service';
import {ModalVisibilityService} from '../../../services/modal-visibility.service';
import {MyDeviceRequestContainerModel} from '../../../models/my-device-request-container.model';
import {MyNotDeviceRequestContainerModel} from '../../../models/my-not-device-request-container.model';
import {SmallTextInfoModalComponent} from '../../small-text-info-modal/small-text-info-modal.component';
import {Subscription} from 'rxjs';
import {IModalDialog} from '@brother-apps/brother-dealerapp-shared-lib';
import {RPriceInfoModel} from '../../../models/r-price-info.model';
import {PriceInfoModel} from '../../../models/price-info.model';
import {EditModalCustomPriceTableService} from '../../../services/edit-modal-custom-price-table.service';
import {MyContainersTableIdEnum} from '../../../enums/my-containers-table-id.enum';
import {ProjectModel} from '../../../models/project.model';
import {ModalDynamicV3Service} from '../../../../../shared-modal-dynamic/services/modal-dynamic-v3-service.service';
import {IModalDialogV3} from '../../../../../shared-modal-dynamic/interfaces/i-modal-dialog-v3';


// step5, used for general supplies shopping active mode (Kafuen),
// contains table of selected supplies on the page bottom
// witch allows to remove or add/confirm supplies in order

@Component({
    selector: 'app-general-supplies-shopping-table',
    templateUrl: './general-supplies-shopping-table.component.html',
    styleUrls: ['./general-supplies-shopping-table.component.scss'],
    viewProviders: [{provide: ControlContainer, useExisting: NgForm}]
})
export class ProjectsGeneralSuppliesShoppingTableComponent
    extends EditModalSectionBaseComponent
    implements OnInit, OnDestroy, AfterViewChecked {

    // public priceLevelBaseChoicesEnum = MyProductRPricesSelectBaseEnum;

    @Input() public forceFormValidationVisibility: boolean;
    private dialogRef: IModalDialogV3;
    // private modalVisibilitySub: Subscription;

    @ViewChildren('dynamicInput') dynamicInputs: QueryList<NgModel>;
    private changesSub: Subscription;
    private tableDataSourceChangedSubscription: Subscription;
    private tableValidatorsInitialized = false;


    constructor(public  editModalService: EditModalService,
                private editModalCustomPriceTableService: EditModalCustomPriceTableService,
                private modalDynamicV3Service: ModalDynamicV3Service,
                private modalVisibilityService: ModalVisibilityService) {
        super(editModalService);
    }


    public async ngOnInit() {
        super.ngOnInit();
        this.tableDataSourceChangedSubscription =
            this.editModalService.tableContentChangedAnnounced$.subscribe(tableId => {
                if (tableId === MyContainersTableIdEnum.step5TableContainers || tableId === MyContainersTableIdEnum.allTablesContainers) {
                    this.activateTableValidators();
                }
            });
    }

    // // returns devices with selected supplies for 5.page general/right tab
    // public getRequestedGeneralSupplyContainers(): MyDeviceRequestContainerModel[] {
    //     if (!this.model.requestedPreselectedGeneralDevicesWithSupplyContainers) {
    //         // this "if" should not be necessary, toto remove it
    //         this.editModalService.refreshAllRequestedGeneralSupplyContainers();
    //     }
    //     return this.model.requestedPreselectedGeneralDevicesWithSupplyContainers;
    // }


    // handle device remove button clicked
    public onDeviceCancelBtnClicked(deviceContainer: MyDeviceRequestContainerModel) {
        deviceContainer.supplies.forEach(supply => {
            supply.parentDeviceDedicatedGeneralSupplyMetadata.addTo5stepOrderList = false;
        });
        this.editModalService.refreshAllRequestedGeneralSupplyContainers();
    }

    // handle supply remove button clicked
    public onCategorizedSupplyCancelBtnClicked(supplyContainer: MyNotDeviceRequestContainerModel) {
        supplyContainer.parentDeviceDedicatedGeneralSupplyMetadata.addTo5stepOrderList = false;
        // note: speed can be increased by removing only dedicated item from RequestedGeneralSupplyContainers
        //       instead of refreshing whole RequestedGeneralSupplyContainers
        this.editModalService.refreshAllRequestedGeneralSupplyContainers();
    }

    public onNoCategorySupplyCancelBtnClicked(supplyContainer: MyNotDeviceRequestContainerModel) {
        supplyContainer.containerSharedMetadata.addToNoCategorised5stepGeneralSupplyOrderList = false;
        // note: speed can be increased by removing only dedicated item from RequestedGeneralSupplyContainers
        //       instead of refreshing whole RequestedGeneralSupplyContainers
        this.editModalService.refreshAllRequestedGeneralSupplyContainers();
    }

    public openAmountInfoPanel(elementRef: HTMLElement) {

        this.modalVisibilityService.announceCloseEditDialogModalsRequest('before_openAmountInfoPanel');

        const dialogHeight = 108;
        const deltaX = 13;
        const deltaY = -35;


        const top = Math.floor(+elementRef.getBoundingClientRect().top) + deltaY;
        const left = Math.floor(+elementRef.getBoundingClientRect().right) + deltaX;


        this.dialogRef = this.modalDynamicV3Service
            .open(SmallTextInfoModalComponent, {
                model: {
                    title: 'Achtung!',
                    messages: ['Die empfohlene Mindestmenge für diesen Artikel ist unterschritten.'],
                    top: top,
                    left: left,
                    showCloseBtn: false,
                    minHeight: dialogHeight,
                    closeEvent: this.modalVisibilityService.closeEditDialogModalsRequestAnnounced$
                }
            }, true);

        // this.modalVisibilitySub = this.modalVisibilityService.closeEditDialogModalsRequestAnnounced$.subscribe(_ => {
        //
        //     if (this.dialogRef) {
        //         this.closeInfoPanel();
        //     }
        // });
    }


    public closeInfoPanel() {
        if (this.dialogRef) {
            this.dialogRef.close();
        }
        // if (this.modalVisibilitySub) {
        //     this.modalVisibilitySub.unsubscribe();
        // }
        this.dialogRef = undefined;
        // this.modalVisibilitySub = undefined;
    }

    public showAmountWarning(supplyContainer: MyNotDeviceRequestContainerModel, project: ProjectModel): boolean {


        if (supplyContainer.parent && supplyContainer.parent.itemToOrder.printSmart) {
            const recommendedAmount = this.editModalService.containerUtilsService.getRecommendedSupplyAmount(supplyContainer, project);

            if (Number.isFinite(recommendedAmount)) {
                const amount: number = supplyContainer.parentDeviceDedicatedGeneralSupplyMetadata &&
                    supplyContainer.parentDeviceDedicatedGeneralSupplyMetadata.amount;

                if (!Number.isFinite(amount)) {
                    return false;
                } else {
                    return amount < recommendedAmount;
                }
            }
        }
        return false;

    }

    public onAddAccessoryItems() {
        const dialogRef: IModalDialogV3 = this.modalDynamicV3Service
            .open(AddSupplyCategorisedModalComponent, {
                model: {}
            });
        dialogRef.subscribe((
            val: {
                action: 'RESET' | 'SUBMIT',
                dialogModel: {
                    categorisedOrderItems: MyDeviceRequestContainerModel[],
                    noParentSupplies: MyNotDeviceRequestContainerModel[]
                }
            }
        ) => {
            this.HandleAddSupplyCategorisedModalResult(val, dialogRef);
        });

    }

    private HandleAddSupplyCategorisedModalResult(
        val: {
            action: 'RESET' | 'SUBMIT'
            dialogModel: {
                categorisedOrderItems: MyDeviceRequestContainerModel[],
                noParentSupplies: MyNotDeviceRequestContainerModel[]
            };
        }, dialogRef: IModalDialog
    ) {

        if (val.action === 'SUBMIT') {
            // this place is what the refreshAllRequestedGeneralSupplyContainers method is made for
            this.editModalService.refreshAllRequestedGeneralSupplyContainers();
        } else {
            // val.action === 'RESET'
            this.editModalService.resetRequestedGeneralSupplyContainersChanges();
        }

        this.activateTableValidators();

    }


    public isInternalUser(): boolean {
        return false;
    }


    public openDisabledInputInfoPanel(elementRef: HTMLElement, deltaX = 0) {

        // console.log('openDisabledInputInfoPanel');

        this.modalVisibilityService.announceCloseEditDialogModalsRequest('before_openDisabledInputInfoPanel');

        const dialogHeight = 109;
        const deltaY = 0;

        const top = Math.floor(+elementRef.getBoundingClientRect().top) + deltaY;
        const left = Math.floor(+elementRef.getBoundingClientRect().right) + deltaX;


        this.dialogRef = this.modalDynamicV3Service
            .open(SmallTextInfoModalComponent, {
                model: {
                    title: 'Achtung!',
                    messages: ['Der Stückpreis wurde bei dem Verbrauchsmaterial bereits ausgewählt.'],
                    top: top,
                    left: left,
                    showCloseBtn: false,
                    minHeight: dialogHeight,
                    closeEvent: this.modalVisibilityService.closeEditDialogModalsRequestAnnounced$
                }
            }, true);

        // this.modalVisibilitySub = this.modalVisibilityService.closeEditDialogModalsRequestAnnounced$.subscribe(_ => {
        //
        //     if (this.dialogRef) {
        //         this.closeInfoPanel();
        //     }
        // });
    }


    private activateTableValidators() {
        if (!this.changesSub) {
            this.changesSub = this.dynamicInputs.changes.subscribe(value => {

                setTimeout(_ => {
                    // console.log('updating validators', value);
                    (value as QueryList<NgModel>).forEach(item => item.control.updateValueAndValidity());
                }, 0);
                this.changesSub.unsubscribe();
                this.changesSub = undefined;
            });
        }
    }


    public getExtendedRPriceChoices(priceInfos: RPriceInfoModel[]): string[] {
        return this.editModalCustomPriceTableService.getExtendedRPriceChoices(priceInfos);
    }

    public getExtendedRPriceValues(priceInfos: RPriceInfoModel[]): string[] {
        return this.editModalCustomPriceTableService.getExtendedRPriceValues(priceInfos);
    }


    public onPriceTypeChanged(priceInfo: PriceInfoModel) {
        return this.editModalCustomPriceTableService.onPriceTypeChanged(priceInfo);
    }


    public isSelectedPriceTypeEqualOtherPrice(priceType: string): boolean {
        return this.editModalCustomPriceTableService.isSelectedPriceTypeEqualOtherPrice(priceType);
    }

    public priceNoteShouldBeVisible(priceType: string): boolean {
        return this.editModalCustomPriceTableService.priceNoteShouldBeVisible(priceType);
    }


    ngAfterViewChecked(): void {
        if (!this.tableValidatorsInitialized) {
            this.tableValidatorsInitialized = true;
            if (this.dynamicInputs.length) {
                setTimeout(_ => {
                    this.dynamicInputs.forEach(item => {
                        item.control.updateValueAndValidity();
                    });
                }, 0);

            }
        }
    }

    public onSetPriceBtnClicked() {
        this.editModalService.set5pageSuppliesPrices();
    }


    public showValidationError(): boolean {
        return  this.forceFormValidationVisibility && !this.editModalService.projectContainsAnythingToOrder();
    }

    public ngOnDestroy(): void {

        if (this.changesSub) {
            this.changesSub.unsubscribe();
        }


        // if (this.modalVisibilitySub) {
        //     this.modalVisibilitySub.unsubscribe();
        // }

        if (this.tableDataSourceChangedSubscription) {
            this.tableDataSourceChangedSubscription.unsubscribe();
        }
    }



}
